import React from 'react';
import { observer } from 'mobx-react-lite';
import { FiltersMap } from '@wix/bex-core';
import { CollectionTableProps } from '../CollectionTable';
import { TableBase } from './TableBase';

export interface TableV2Props<T, F extends FiltersMap>
  extends CollectionTableProps<T, F> {}

function _TableV2<T, F extends FiltersMap = FiltersMap>(
  props: TableV2Props<T, F>,
) {
  return <TableBase {...props} />;
}

export const TableV2 = observer(_TableV2);
